import { DocumentDataType } from '@/types/doc';
import { create } from 'zustand';

interface DocumentStore {
  selectedFiles: File[] | null;
  documents: DocumentDataType[];
  setSelectedFiles: (files: File[] | null) => void;
  setDocuments: (documents: DocumentDataType[]) => void;
  clearSelectedFiles: () => void;
  clearSelectedFile: (fileToRemove: File) => void;
}

export const useDocumentStore = create<DocumentStore>((set) => ({
  selectedFiles: null,
  documents: [],
  setSelectedFiles: (files) => set({ selectedFiles: files }),
  setDocuments: (documents) => set({ documents }),
  clearSelectedFiles: () => set({ selectedFiles: null }),
  clearSelectedFile: (fileToRemoveId) =>
    set((state) => ({
      selectedFiles:
        state.selectedFiles?.filter((file) => file.id !== fileToRemoveId) ||
        null,
    })),
}));
